import Layout from "@/components/site/Layout";
import Seo from "@/components/site/Seo";
import Hero from "@/components/site/Hero";
import Mission from "@/components/site/Mission";
import Services from "@/components/site/Services";
import Stats from "@/components/site/Stats";
import ServiceAreas from "@/components/site/ServiceAreas";
import WhyChooseUs from "@/components/site/WhyChooseUs";
import Process from "@/components/site/Process";
import Testimonials from "@/components/site/Testimonials";
import ContactSection from "@/components/site/ContactSection";
import RecentJobs from "@/components/site/RecentJobs";
import Pricing from "@/components/site/Pricing";
import HomeFaq from "@/components/site/HomeFaq";
import { localBusinessSchema } from "@/lib/schema";
import { PHONE_DISPLAY } from "@/config/site";

// Homepage order (luxury cinematic flow):
// Hero (real photo + Quote) → Mission → Stats → Services (bento glass) →
// Why → Testimonials → Service Areas → Pricing → Recent Jobs → Process → FAQ → Contact

export default function Home() {
  const url = typeof window !== "undefined" ? window.location.origin + "/" : "/";
  return (
    <Layout>
      <Seo
        title={`Towing Service in Bellevue, WA | BM Towing & Recovery`}
        description="BM Towing & Recovery is your local 24/7 tow truck in Bellevue, WA. Fast towing, flatbed transport, roadside assistance, jump starts, lockouts, tire changes, and vehicle transport — also serving Kirkland, Redmond, and the Eastside. Call (425) 647-9585."
        canonical={url}
        ogImage="/images/hero-porsche.webp"
        jsonLd={localBusinessSchema({ url })}
      />
      <Hero />
      <Mission />
      <Stats />
      <Services />
      <WhyChooseUs />
      <Testimonials />
      <ServiceAreas />
      <Pricing />
      <RecentJobs />
      <Process />
      <HomeFaq />
      <ContactSection />
    </Layout>
  );
}
